module.exports = __webpack_public_path__ + "img/postgreSQL.b269c874.png";